import MyName from "./MyName";
import AboutMe from "./AboutMe";
import Timeline from "./Timeline";
import Projects from "./Projects";


function Home() {
  return ( 
  	<div className="home">
      <MyName />
      <AboutMe />
      <Timeline />
      <Projects />
    </div>
  );
}

export default Home;